import VIC_1 from '../assets/vic-1.webp';
import VIC_2 from '../assets/vic-2.webp';

export const FLOOR_PLANS_LAYOUT = {
  'vic-1': {
    image: VIC_1,
    totalApartments: '1,446',
    totalElevators: 17,
    floors: {
      '6-22': '/assets/images/floorPlans/vic1/6-22.webp',
      '23-25': '/assets/images/floorPlans/vic1/23-25.webp',
      '26-28': '/assets/images/floorPlans/vic1/26-28.webp',
    },
  },
  'vic-2': {
    image: VIC_2,
    totalApartments: '1,446',
    totalElevators: 17,
    floors: {
      '6-22': '/assets/images/floorPlans/vic2/6-22.webp',
      '23-25': '/assets/images/floorPlans/vic2/23-25.webp',
      '26-28': '/assets/images/floorPlans/vic2/26-28.webp',
    },
  },
};
